const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const prettify = (str, description) => {
  return `Sergio Olmeda ${(description) ? description : capitalize(str.split('.')[0].replace(/-/ig, ' '))} luz y medio digital`;
}
export default prettify;